<template>
  <div v-if="scoreTemplates != null" class="container">
    <h5>Score Templates</h5>
    <div
      class="card text-left mb-2"
      v-for="template in scoreTemplates
        .filter(t => t.Score_Template_Type_Id == 1)
        .slice()
        .sort($orderByTitle)"
      :key="template.Score_Template_Id"
    >
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5>
              {{ template.Title }}
            </h5>
          </div>
          <div class="col-auto">
            <p
              class="text-secondary"
              v-if="
                !(
                  template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  )
                )
              "
            >
              You cannot edit or delete this template because you are not the
              creator or a school manager.
            </p>
            <p
              class="text-secondary"
              v-else-if="template.Units.some(u => u.Num_Scores > 0)"
            >
              <small>
                You cannot edit this template because data has been taken using
                this template.
              </small>
            </p>
            <p class="text-secondary" v-else-if="template.Units.length > 0">
              <small>
                You cannot delete this template because it is assigned to a
                unit.
              </small>
            </p>
          </div>
          <div
            class="col-auto"
            v-if="
              !template.Units.some(u => u.Num_Scores > 0) &&
                (template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  ))
            "
          >
            <button class="btn btn-primary" v-on:click="editTemplate(template)">
              Edit
            </button>
          </div>
          <div
            class="col-auto pl-0"
            v-if="
              template.Units.length == 0 &&
                (template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  ))
            "
          >
            <button
              class="btn btn-danger"
              v-on:click="deleteTemplate(template)"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <p><b>Inputs</b></p>
            <div
              class="ml-3"
              v-for="input in template.Score_Template_Inputs.slice().sort(
                $orderByOrder
              )"
              :key="input.Score_Template_Input_Id"
            >
              <label class="mb-0">{{ input.Order }}) {{ input.Request }}</label>
              <label class="ml-2"
                ><small
                  >({{ $getScoreTemplateInputSummary(input) }})</small
                ></label
              >
            </div>
          </div>
          <div class="col border-left">
            <p><b>Units Using Template</b></p>
            <div
              class="ml-3"
              v-for="unit in template.Units.slice().sort($orderByTitle)"
              :key="unit.Unit_Id"
            >
              <label
                >{{ unit.Title }}
                <small>(Number of scores: {{ unit.Num_Scores }})</small></label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <h5>Behavior Templates</h5>
    <div
      class="card text-left mb-2"
      v-for="template in scoreTemplates
        .filter(t => t.Score_Template_Type_Id == 2)
        .slice()
        .sort($orderByTitle)"
      :key="template.Score_Template_Id"
    >
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5>
              {{ template.Title }}
            </h5>
          </div>
          <div class="col-auto">
            <p
              class="text-secondary"
              v-if="
                !(
                  template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  )
                )
              "
            >
              You cannot edit or delete this template because you are not the
              creator or a school manager.
            </p>
            <p
              class="text-secondary"
              v-else-if="template.Behavior_Trackers.some(u => u.Num_Scores > 0)"
            >
              <small>
                You cannot edit this template because data has been taken using
                this template.
              </small>
            </p>
            <p
              class="text-secondary"
              v-else-if="template.Behavior_Trackers.length > 0"
            >
              <small>
                You cannot delete this template because it is assigned to a
                behavior tracker.
              </small>
            </p>
          </div>
          <div
            class="col-auto"
            v-if="
              !template.Behavior_Trackers.some(u => u.Num_Scores > 0) &&
                (template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  ))
            "
          >
            <button class="btn btn-primary" v-on:click="editTemplate(template)">
              Edit
            </button>
          </div>
          <div
            class="col-auto pl-0"
            v-if="
              template.Behavior_Trackers.length == 0 &&
                (template.Created_By == $store.getters.user.User_Id ||
                  $canManageOrganization(
                    $store.getters.user.Permissions,
                    template.Organization_Id
                  ))
            "
          >
            <button
              class="btn btn-danger"
              v-on:click="deleteTemplate(template)"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <p><b>Inputs</b></p>
            <div
              class="ml-3"
              v-for="input in template.Score_Template_Inputs.slice().sort(
                $orderByOrder
              )"
              :key="input.Score_Template_Input_Id"
            >
              <label class="mb-0">{{ input.Order }}) {{ input.Request }}</label>
              <label class="ml-2"
                ><small
                  >({{ $getScoreTemplateInputSummary(input) }})</small
                ></label
              >
            </div>
          </div>
          <div class="col border-left">
            <p><b>Behavior Trackers Using Template</b></p>
            <div
              class="ml-3"
              v-for="tracker in template.Behavior_Trackers.slice().sort(
                $orderByTitle
              )"
              :key="tracker.Behavior_Tracker_Id"
            >
              <label
                >{{ tracker.Title }}
                <small
                  >(Number of scores: {{ tracker.Num_Scores }})</small
                ></label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmDeleteModal
      v-bind:DeletingTitle="templateToDelete.Title"
      @confirm-delete="confirmDeleteTemplate"
    />
    <EditScoreTemplateModal
      v-bind:ScoreTemplate="templateToEdit"
      @template-updated="updatedTemplate"
    />
  </div>
</template>

<script>
import $ from "jquery";
import ConfirmDeleteModal from "@/modals/ConfirmDeleteModal.vue";
import EditScoreTemplateModal from "@/modals/Templates/EditScoreTemplateModal.vue";

export default {
  components: {
    ConfirmDeleteModal,
    EditScoreTemplateModal
  },
  data() {
    return {
      scoreTemplates: null,
      templateToDelete: {},
      templateToEdit: null
    };
  },
  watch: {
    "$store.getters.user": async function() {
      this.loadTemplates();
    }
  },
  async mounted() {
    this.loadTemplates();
  },
  methods: {
    async loadTemplates() {
      var view = this;
      if (view.$store.getters.user != null) {
        this.$store.commit("updateLoading", true);
        view.scoreTemplates = await this.$getMyManageScoreTemplates();
        this.$store.commit("updateLoading", false);
      }
    },
    deleteTemplate(template) {
      this.templateToDelete = template;
      $("#confirmDeleteModal").modal("show");
    },
    async confirmDeleteTemplate() {
      $("#confirmDeleteModal").modal("hide");
      this.$store.commit("updateLoading", true);
      await this.$deleteScoreTemplate(this.templateToDelete.Score_Template_Id);
      this.scoreTemplates = this.scoreTemplates.filter(
        t => t.Score_Template_Id != this.templateToDelete.Score_Template_Id
      );
      this.templateToDelete = {};
      this.$store.commit("updateLoading", false);
    },
    editTemplate(template) {
      this.templateToEdit = template;
      $("#editScoreTemplateModal").modal("show");
    },
    updatedTemplate(template) {
      var editedIndex = this.scoreTemplates.findIndex(
        t => t.Score_Template_Id == template.Score_Template_Id
      );
      this.$set(this.scoreTemplates, editedIndex, template);
      this.templateToEdit = null;
    }
  }
};
</script>
